var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"priceAdjustments"}},[_c('PageTitle',{attrs:{"title":_vm.$t('pos.price_adjustments'),"subtitle":_vm.$t('pos.price_adjustments_description')}}),_c('div',{staticClass:"container"},[_c('Panel',{attrs:{"showTitle":false}},[_c('Datatable',{attrs:{"entity":"sale_item_price_change","parameters":_vm.parameters}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }